import React from "react";
import { connect } from "react-redux";
import HeaderPlanMovilidad from "../Util/Header";
import Grafico from "./grafico";
import { changeTabIndex } from "../../Header/actions";
import { openCloseToast } from "../../Global/actions";
import {
  getListadoPlanesMovilidad,
  crearPlanMovilidad,
  getEstadisticasPlanMovilidad,
  changeFlagCargaInicial,
  offAlertaPlanMovilidad,
  getListadoContenidosCompleto,
  loadMenuInicio as loadMenuInicioAction } from "../Planes/actions";
import Loading from "../Util/Loading";
import MenuItem from "./menuItem";
import { dataLayerTag } from "../Planes/functions";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../helpers/rolAccess";
import { paths } from "../../../config/routes";

class InicioPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadMenuInicio();
  }

  loadMenuInicio = () => {
    const tabs = [
      { text: "Sensibilización", contentId: 0 },
      { text: "Diagnóstico", contentId: 1 },
      { text: "Plan de Acción", contentId: 2 },
      { text: "Ejecución y Seguimiento", contentId: 3 },
    ];
    this.props.dispatch(loadMenuInicioAction(tabs));
  }

  componentDidMount = () => {
    if (!this.props.cargaInicial && this.props.companyId !== null) {
      this.preLoadPlanMovilidad();
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!this.props.cargaInicial && this.props.companyId !== null) {
      this.preLoadPlanMovilidad();
    }
    // manejo las alertas
    if (this.props.alertaCall) {
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: this.props.alertaMensaje,
        typeStyle: this.props.alertaCode,
        displayTime: 5000
      }));
      this.props.dispatch(offAlertaPlanMovilidad());
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  preLoadPlanMovilidad = () => {
    const { dispatch, companyId, sucursalId, sucursalName, usuarioRUT } = this.props;
    /* dispatch(getListadoContenidosCompleto());
    dispatch(getEstadisticasPlanMovilidad(companyId, sucursalId, ""));
    dispatch(getListadoPlanesMovilidad(companyId, sucursalId, usuarioRUT));
    dispatch(changeFlagCargaInicial(true)); */
    /* this.loadMenuInicio(); */
    // gtm
    dataLayerTag({
      'event': 'sucursal_seleccionada',
      'rut': usuarioRUT,
      'sucursal': (sucursalName? sucursalName: 'undefined'),
      'bp_sucursal': (sucursalId && sucursalId !== "" ? sucursalId : 'undefined'),
      });
  }

  render() {
    return (
      <div id="plan_de_movilidad_principal">
        { this.props.isLoading && <Loading /> }
        <HeaderPlanMovilidad />
        {
          (this.props.sucursalId !== "") ?
            <section id="PM-alerta">
              <div className="container-fluid">
                {
                  ( this.props.ultimoEstadoProceso === 0 ) ?
                    <div className="alert PM-alert-achs-plan text-right" role="alert">
                      <span>Crear Plan de Movilidad</span>
                      <button
                        type="button"
                        className="btn PM-dx-button-plan"
                        onClick={() => { this.props.dispatch(crearPlanMovilidad(this.props.companyId, this.props.companyName, this.props.sucursalId, this.props.sucursalName, this.props.usuarioRUT, this.props.usuarioNombre, this.props.usuarioApellido, this.props.usuarioEmail)); }}
                      > Crear
                      </button>
                    </div>
                    :
                    <div className="alert PM-alert-achs-plan text-right" role="alert">
                        <span>Continúa con tu plan de movilidad</span>
                        <button
                          type="button"
                          className="btn PM-dx-button-plan"
                          onClick={() => { this.props.dispatch(changeTabIndex(1, 1)); }}
                        >Continuar
                        </button>
                      </div>
                }
              </div>
            </section>
            :
            <div></div>
        }

        <section id="plan-e" className="pt-20">
          <MenuItem />
        </section>

        <section id="indicadores-e" className="pt-20">
          <div className="container-fluid">
            <div className="text-center pt-20">
              <h3 className="section-title">Accidentes de Trayecto</h3>
            </div>
            <div className="row">
              <div className="col-md-12 padding">
                <div className="PM-plan-borde-spacing">
                  <div className="col-md-12 PM-cuadro-3">
                    <React.Fragment >
                      {this.props.EmbedTokenPowerBi ? <Grafico /> : null}
                    </React.Fragment>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center" style={{ paddingTop: 50 }}>
              <h3 className="section-title">Mis Indicadores de Avance</h3>
            </div>
            <div className="row" style={{ marginTop: 30 }}>
              <div className="col-md-6 padding">
                <div className="col text-center PM-plan-borde-spacing">
                  <h3>{this.props.totalPlanesEjecucion}</h3>
                  { (this.props.sucursalId !== "") ? <span>Planes en ejecución</span> : <span>Planes en ejecución en la empresa</span> }
                </div>
              </div>
              <div className="col-md-6 padding2">
                <div className="col text-center PM-plan-borde-spacing">
                  <h3>{this.props.porcentajeAvance}%</h3>
                  { (this.props.sucursalId !== "") ? <span>Avance del Plan</span> : <span>Avance de Planes en la empresa</span> }
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>);
  }
}

const mapStateToProps = (state) => ({
  ultimoEstadoProceso: state.planMovilidad.ultimoEstadoProceso,
  estadoProceso: state.planMovilidad.estadoProceso,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  sucursalId: state.global.sucursalId,
  sucursalName: state.global.sucursalName,
  companyId: state.global.companyId,
  companyName: state.global.companyName,
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  porcentajeAvance: state.planMovilidad.porcentajeAvance,
  totalPlanesEjecucion: state.planMovilidad.totalPlanesEjecucion,
  isLoading: state.planMovilidad.isLoading,
  cargaInicial: state.planMovilidad.cargaInicial,
  alertaCall: state.planMovilidad.alertaCall,
  alertaCode: state.planMovilidad.alertaCode,
  alertaMensaje: state.planMovilidad.alertaMensaje,
  esEncargado: state.planMovilidad.esEncargado,
  usuarioEmail: state.global.userData.Email,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InicioPlanMovilidad);
